import { InvoicesDCService } from './../../services/invoices-dc/invoices-dc.service';
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { GeneralService } from './../../services/admin/general.service';
import { ToasterModule, ToasterService, Toast, ToasterConfig } from 'angular5-toaster';
import { CatalogsService } from './../../services/catalogs/catalogs.service';
import { StorageService } from '../../services/storage.service';
import { User } from '../../models/user';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError } from 'rxjs/operators';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { concat } from 'rxjs/observable/concat';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/map';
import { TranslateService } from '@ngx-translate/core';
import { ResponseModal2Component } from './../../components/response-modal2/response-modal2.component';


@Component({
  selector: 'app-invoices-dc',
  templateUrl: './invoices-dc.component.html',
  styleUrls: ['./invoices-dc.component.scss'],
  providers: [GeneralService, CatalogsService, InvoicesDCService]
})
export class InvoicesDCComponent implements OnInit {
  @ViewChild('myTable') table: any;
  @Input() messages: any = {
    emptyMessage: '',
    totalMessage: '',
    selectedMessage: ''
  };
  public user: User;
  rol;
  pais;
  flagMostrarXML = false;
  flagMostrarPDF = false;
  flagFile = false;
  flagFiles = false;
  checkCFDI;
  flagCFDI = false;
  proveedores;
  monedaCatalogo;
  descripcion;
  importe;
  moneda;
  total;
  importeTotal = 0;
  flagMostrarImporte = false;
  proveedor;
  proveedorFilter;
  anioDocumento;
  statusRespuesta;
  mensajeRespuesta;
  modalRespuesta;
  flagEnviar = false;
  flagTabla = true;
  flagCheckCFDI;
  tabla;
  arrayTabla = [];
  rows = [];
  closeResult: string;

  switchTipo = false;
  noDocumentoSAP;
  personaContacto;
  sociedadFilter;
  mensajeEnvioC;
  mensajeEnvioE;

  proveedores$: Observable<any>;
  proveedoresLoading = false;
  proveedorinput$ = new Subject<string>();

  busy: boolean = false;
  busyEnvio: boolean = false;
  public form: FormGroup;

  listaProveedores;
  paisProveedor;
  sociedades;
  toastCamposVacios;
  public toasterconfig: ToasterConfig =
    new ToasterConfig({ timeout: 500 });
  constructor(
    private translate: TranslateService,
    private general: GeneralService,
    private toasterService: ToasterService,
    private storageService: StorageService,
    private catalogos: CatalogsService,
    private InvoicesDCService: InvoicesDCService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder
  ) {
    this.getProveedores();
    this.translate.get('texto.noHayInformacionLabel').subscribe(
      text => {
        this.messages.emptyMessage = text;
      });

    this.translate.get('texto.totalLabel').subscribe(
      text => {
        this.messages.totalMessage = text;
      });

    this.translate.get('texto.seleccionadoLabel').subscribe(
      text => {
        this.messages.selectedMessage = text;
      });

    this.translate.get('texto.toastCamposVacios').subscribe(
      text => {
        this.toastCamposVacios = text;
      });

    this.translate.get('texto.informacionEnviada').subscribe(
      text => {
        this.mensajeEnvioC = text;
      });

    this.translate.get('texto.errorEnviarInformacion').subscribe(
      text => {
        this.mensajeEnvioE = text;
      });

  }

  ngOnInit() {
    this.noBack();
    this.modulo();
    this.user = this.storageService.getCurrentUser();
    this.rol = this.user.rol.id;
    this.pais = this.user.pais;
    this.getSociedades();
    this.obtenerMoneda();
    //  if (this.rol === 3) {
    if (this.pais === 'MX') {
      //this.flagMostrarXML = true;
      //this.flagMostrarPDF = true;
      //this.flagFiles = true;
      //this.flagCheckCFDI = true;
    } else {
      //this.flagMostrarXML = false;
      //this.flagMostrarPDF = true;
      //this.flagFile = true;
      //this.flagCFDI = true;
      //this.flagCheckCFDI = false;
    }
    /*  } else if (this.rol === 2) {
        this.flagMostrarPDF = true;
        this.flagMostrarXML = true;
        this.flagFiles = true;
        this.flagCheckCFDI = true;
      } */

    this.paisProveedor = this.pais;
    if (this.rol === 3) {
      if (this.pais == 'MX') {
        this.flagMostrarXML = true;
        this.flagMostrarPDF = true;
        this.flagFiles = true;
        this.flagCFDI = false;
        this.flagCheckCFDI = true;
      } else {
        this.flagMostrarXML = false;
        this.flagMostrarPDF = true;
        this.flagFile = true;
        this.flagCFDI = true;
        this.flagCheckCFDI = false;
      }
      this.paisProveedor = this.pais;
    } else {
      this.flagMostrarPDF = true;
      this.flagMostrarXML = true;
    
      this.getProveedoresLista();
    }

    this.validarFormulario();
    var anio = new Date().getFullYear();
    this.anioDocumento = anio;
  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  validarFormulario() {
    if (this.paisProveedor == 'MX') {
      this.form = this.formBuilder.group({
        switchTipo: [{ value: false, disabled: true }],
        correo: ['', Validators.compose([Validators.required,
        Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$'),
        Validators.minLength(1)])],
        documentoSap: ['', Validators.compose([Validators.required,
          Validators.pattern('^[0-9]*$')])],
        anioDocumento: [this.anioDocumento, Validators.compose([Validators.required,
          Validators.pattern('^[0-9]*$')])]
      });
    } else {
      this.form = this.formBuilder.group({
        correo: ['', Validators.compose([Validators.required,
        Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$'),
        Validators.minLength(1)])],
        documentoSap: ['', Validators.compose([Validators.required,
          Validators.pattern('^[0-9]*$')])],
        anioDocumento: [this.anioDocumento, Validators.compose([Validators.required,
          Validators.pattern('^[0-9]*$')])],
        importe: ['', Validators.compose([Validators.required,
        Validators.pattern('^[0-9]+(\.[0-9]{1,2})?$')])],
        monedaForm: ['', Validators.compose([Validators.required])],
        sociedadForm: ['', Validators.compose([Validators.required])]
      });
    }
  }

  modulo() {
    this.general.serviceLog('Facturas a documentos contables').subscribe(
      data => {
        // console.log(data);
      },
      err => {
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  getProveedoresLista() {
    this.busy = true;
    this.catalogos.obtenerProveedores().subscribe(
      data => {
        this.busy = false;
        this.listaProveedores = data.sapProveedor;
      },
      err => {
        // console.log(err);
      },
    );
  }

  tProveedor(e) {
    if (e) {
      this.paisProveedor = e.pais;
      if (e.pais == 'MX') {
        this.flagMostrarXML = true;
        this.flagMostrarPDF = true;
        this.flagFiles = true;
        this.flagFile = false;
        this.flagCFDI = false;
        this.flagCheckCFDI = true;
      } else {
        this.flagMostrarXML = false;
        this.flagMostrarPDF = true;
        this.flagFiles = false;
        this.flagFile = true;
        this.flagCFDI = true;
        this.flagCheckCFDI = false;
      }

      var anio = new Date().getFullYear();
      this.anioDocumento = anio;
      this.validarFormulario();
    }
  }


  getSociedades() {
    this.busy = true;
    this.catalogos.obtenerSociedades().subscribe(
      data => {
        this.busy = false;
        this.sociedades = data.sapSociedad;
      },
      err => {
        this.busy = false;
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  obtenerMoneda() {
    this.busy = true;
    this.catalogos.obtenerMonedaPorModulo('P').subscribe(
      data => {
        this.monedaCatalogo = data.moneda;
        this.busy = false;
      },
      err => {
        this.busy = false;
        if (err.status === 401) {
          this.storageService.openLogout();
        } 
      },
    );
  }

  getProveedores() {
    this.proveedores$ = concat(of([]),
      this.proveedorinput$.pipe(
        debounceTime(200),
        distinctUntilChanged(),

        tap(() => this.proveedoresLoading = true),
        switchMap(term =>
          this.catalogos.obtenerProveedoresBusqueda(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => this.proveedoresLoading = false)
          ))
      )
    );
  }

  customSearchFn(term: string, item) {
    term = term.toLocaleLowerCase();
    return item.name1.toLocaleLowerCase().indexOf(term) > -1 || item.lifnr.toLocaleLowerCase().indexOf(term) > -1;
  }


  cfdiStatus() {
    const checkCFDI = this.checkCFDI;
    if (checkCFDI === false) {
      this.flagMostrarPDF = true;
      this.flagMostrarXML = true;
      this.flagFiles = true;
      this.flagFile = false;
      this.flagCFDI = false;
    } else {
      this.flagMostrarPDF = true;
      this.flagMostrarXML = false;
      this.flagFile = true;
      this.flagFiles = false;
      this.flagCFDI = true;
    }
  }

  statusSendInvoice;
  uploadConCfdi(respuesta, file1: File, file2: File) {
    this.busyEnvio = true;
    const moneda = '';
    const total = '';
    let tipoProceso;
    let flagEnviar;

    if (this.switchTipo) {
      tipoProceso = "T";
    } else {
      tipoProceso = "C";
    }

    let archivoPDF, archivoXML;
    if (file1 == null || file1 == undefined) {
      archivoPDF = '';
    } else {
      archivoPDF = file1;
    }

    if (file2 == null || file2 == undefined) {
      archivoXML = '';
    } else {
      archivoXML = file2;
    }

    if (this.rol === 3) {
      this.proveedor = this.user.id;

    } else {
      this.proveedor = this.proveedorFilter;
      /* if (file2 && this.proveedor) {
         flagEnviar = true;
       } else {
          flagEnviar = false;
       } */
    }

    if (this.paisProveedor == 'MX') {
      this.flagCFDI = false;
      if (file2) {
        flagEnviar = true;
      } else {
        flagEnviar = false;
      }
    } else {
      this.flagCFDI = true;
      if (file1) {
        flagEnviar = true;
      } else {
        flagEnviar = false;
      }
    }

    if (flagEnviar && this.form.valid) {
      const formData: FormData = new FormData();
      formData.append('archivoxml', archivoXML);
      formData.append('archivopdf', archivoPDF);
                                                               
      this.InvoicesDCService.cargarFactura(this.flagCFDI, this.proveedor, tipoProceso, this.form.value, formData).subscribe(
        data => {
          this.busyEnvio = false;

          if (data != null) {
            this.statusRespuesta = data.result.status;
            this.mensajeRespuesta = data.result.message;
            this.statusSendInvoice = data.result.status;

            if (this.statusRespuesta == 'S') {
              this.switchTipo = false;
              this.proveedorFilter = null;
              this.noDocumentoSAP = '';
              this.personaContacto = '';
              this.sociedadFilter = '';
              this.anioDocumento = '2019';
              this.importe = '';
              this.moneda = '';
              this.statusRespuesta = this.mensajeEnvioC;
              const modalRef = this.modalService.open(ResponseModal2Component, { centered: true, keyboard: false, backdrop: 'static' });
              modalRef.componentInstance.titulo = this.statusRespuesta;
              modalRef.componentInstance.mensaje1 = this.mensajeRespuesta;
              modalRef.componentInstance.status = this.statusSendInvoice;
              
              modalRef.result.then((result) => {
                // console.log(result);

              });
            } else {
              this.statusRespuesta = this.mensajeEnvioE;
              const modalRef = this.modalService.open(ResponseModal2Component, { centered: true, keyboard: false, backdrop: 'static' });
              modalRef.componentInstance.titulo = this.statusRespuesta;
              modalRef.componentInstance.mensaje1 = this.mensajeRespuesta;

              modalRef.result.then((result) => {
                // console.log(result);

              });
            }
          }


          this.importeTotal = 0;
          this.proveedorFilter = '';
        },
        err => {
          this.busyEnvio = false;
          if (err.status === 401) {
            this.storageService.openLogout();
          } 
        },
      );

    } else {
      this.busyEnvio = false;
      this.toasterService.pop('error', 'Error', this.toastCamposVacios);
    }
  }


  openRespuesta(respuesta) {
    this.modalRespuesta = this.modalService.open(respuesta, { centered: true, keyboard: false, backdrop: 'static' });
    this.modalRespuesta.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReasonFiltersOC(reason)}`;
    });
  }

  private getDismissReasonFiltersOC(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/invoices-dc/invoices-dc.component.ts